import React, {useContext} from "react";
import Context from "../Context";
import styled from "@emotion/styled";
import { Sizes, Colors } from "../../../styles";


const PressReleaseList = () => {
	const { data: { items } } = useContext(Context);

	const renderPressReleases = (items) => {
		if (!items.length) return null;

		return items.map((item) => {
			return (
				<PressReleaseCard key={item.id}>
					<Date>{item.date}</Date>
					<Title><Link href={item.url}>{item.title}</Link></Title>
					<Arrow>
						<svg viewBox="0 0 23 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clipRule="evenodd" d="M17.4398 7.99779C17.441 7.9512 17.4344 7.90481 17.4205 7.86137C17.4066 7.81793 17.3858 7.77832 17.3591 7.74489C17.3324 7.71146 17.3005 7.68489 17.2652 7.66675C17.23 7.64861 17.1921 7.63928 17.1538 7.6393C15.9171 7.53687 13.7887 7.38323 11.2648 7.32178L8.741 7.32178C7.89972 7.32178 7.05844 7.32178 6.21716 7.39348C4.21492 7.47542 2.19585 7.60857 0.328207 7.72124C0.284403 7.72122 0.24104 7.73188 0.200675 7.75259C0.160309 7.7733 0.123759 7.80365 0.09318 7.84183C0.0626006 7.88002 0.0386111 7.92527 0.0226261 7.97492C0.00664123 8.02458 -0.00101542 8.07762 0.000107744 8.13094C4.753e-05 8.18382 0.00883952 8.23616 0.0259471 8.28477C0.0430546 8.33338 0.0681188 8.37723 0.0996099 8.41366C0.131101 8.45008 0.168358 8.47831 0.209108 8.49662C0.249857 8.51493 0.293244 8.52294 0.336619 8.52015C2.17061 8.52015 4.18968 8.63282 6.22557 8.66355L8.74941 8.66355L11.2733 8.66355C13.7971 8.57137 15.875 8.41773 17.1622 8.387C17.2025 8.38757 17.2424 8.37746 17.2791 8.35736C17.3159 8.33727 17.3486 8.30768 17.375 8.27065C17.4014 8.23361 17.4209 8.19002 17.4321 8.14291C17.4433 8.09579 17.4459 8.04627 17.4398 7.99779Z" fill="currentColor"/>
							<path fillRule="evenodd" clipRule="evenodd" d="M21.8316 6.59462C21.4553 6.10727 21.0131 5.67452 20.5178 5.30876L16.5484 2.03819C16.139 1.69615 15.7096 1.37878 15.2625 1.08777C15.0749 0.965917 14.8572 0.898208 14.6336 0.89209C14.5075 0.89209 14.3866 0.942157 14.2975 1.03128C14.2084 1.1204 14.1583 1.24127 14.1583 1.3673C14.1583 1.77263 14.1583 1.3673 15.7657 2.9327L19.3437 6.59462C19.5115 6.76234 19.777 6.972 20.0146 7.22358C20.2522 7.47516 20.392 7.54504 20.2662 7.55902C20.1753 7.76668 20.0474 7.95611 19.8888 8.11809C19.6093 8.43956 19.2878 8.73307 19.0782 8.94272C18.5201 9.5587 17.9225 10.1376 17.2891 10.6758C16.6714 11.2222 16.0177 11.7265 15.3324 12.1853L13.3617 13.583C13.1359 13.7293 12.9372 13.9138 12.7746 14.1281C12.6867 14.2485 12.648 14.3978 12.6661 14.5458C12.6843 14.6937 12.7581 14.8292 12.8725 14.9248C13.3197 15.372 13.0681 15.0506 16.0452 13.4153C16.8324 13.0042 17.5891 12.5371 18.3094 12.0176C19.0319 11.4904 19.7226 10.921 20.378 10.3124C20.8481 9.88648 21.2785 9.41866 21.6639 8.91477C21.9005 8.60115 22.063 8.23797 22.1391 7.85253C22.1858 7.41024 22.0771 6.96549 21.8316 6.59462Z" fill="currentColor"/>
						</svg>
					</Arrow>
				</PressReleaseCard>
			);
		});
	}

	return (
		<PressReleaseListContainer>
			{renderPressReleases(items)}
		</PressReleaseListContainer>
	)
}

export default PressReleaseList;

const PressReleaseListContainer = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 7.5rem auto 4rem auto;

    @media only screen and (min-width: ${Sizes.screens.large}) {
        margin-top: 11rem;
        margin-bottom: 6rem;    
    }
`;

const Link = styled.a`
    display: block;
    margin-right: 9rem;

    &::after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
`;

const Arrow = styled.div`
    position: absolute;
    height: 5rem;
    width: 5rem;
    right: 4rem;
    top: 50%;
    transform: translateY(-50%);
    transition: right 0.3s ease;
    background-color: ${Colors.fp.pineGreen60};
    border-radius: 50%;
    transition: right 0.3s ease, color 0.3s ease;
    pointer-events: none;

    svg {
        height: 1.6rem;
        width: 2.3rem;
        position: absolute;
        top: 50%;
        right: 5%;
        transform: translate(-50%, -50%);
    }
`;

const PressReleaseCard = styled.li`
    position: relative;
    margin-bottom: unset;
    border: 0.3rem solid ${Colors.fp.pineGreen80};
    margin-bottom: 2rem;
    padding: 2.85rem 4rem;
    border-radius: 3rem;
    background-color: ${Colors.fp.pineGreen5};
    
    @media only screen and (min-width: ${Sizes.screens.large}) {
        display: grid;
        grid-template-columns: minmax(auto, 27rem) minmax(auto, 90rem);
        column-gap: 4rem;
        align-items: center;
    }

    &:last-of-type {
        margin-bottom: 0;
    }

    &:hover {
        ${Arrow} {
            @media only screen and (min-width: ${Sizes.screens.large}) {
                right: 2rem;
                color: ${Colors.base.white};
            }
        }
    }

    &:focus-within {
        ${Arrow} {
            @media only screen and (min-width: ${Sizes.screens.large}) {
                right: 2rem;
                color: ${Colors.base.white};
            }
        }
    }
`;

const Date = styled.p`
    font-size: 1.8rem;
    line-height: 1.9rem;
    letter-spacing: -0.036px;
    margin-bottom: 0.5rem;

    @media only screen and (min-width: ${Sizes.screens.large}) {
        font-size: 1.8rem;
        line-height: 1.9rem;
    }
`;

const Title = styled.h5`
    font-size: 2rem;
    line-height: 2.1rem;
    letter-spacing: -0.005em;
    letter-spacing: -0.1px;

    @media only screen and (min-width: ${Sizes.screens.large}) {
        font-size: 2rem;
        line-height: 2.1rem;
    }
`;
